exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-not-found-container{margin-top:40px}.page-not-found-container md-icon{color:#0096d6;width:40%;height:40%;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/page-not-found/page-not-found.scss
// module id = 118
// module chunks = 0